import { Navigate, useLocation } from "react-router-dom";
import { useAdminAuth } from "@/contexts/AdminAuthContext";

export default function PartnerProtectedRoute({ children }) {
  const { isAuthenticated, admin, loading } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div
        data-testid="partner-loading"
        className="min-h-screen flex items-center justify-center bg-[#f7fafc]"
      >
        <div className="text-[13px] font-semibold text-[#5b6b7a]">Chargement…</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  if (admin?.role !== "partner") {
    // Authenticated as admin/super_admin -> not allowed in partner space
    return <Navigate to="/admin" replace />;
  }

  return children;
}
